import React, { useState } from "react";
import Button from "../../common/components/Button";
import PropTypes from "prop-types";
import LoadingSpinner from "../../common/components/LoadingSpinner";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Tooltip from "@mui/material/Tooltip";
import { Fab } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const ExternalTable = ({ loading, data, onAddAll }) => {
  const [copied, setCopied] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [isAdding, setIsAdding] = useState(false);

  if (loading) {
    return (
      <LoadingSpinner
        style={{ margin: "80px auto", position: "relative", top: "unset" }}
      />
    );
  }

  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const handleAddAll = async () => {
    if (isAdding) return;

    const idsToAdd = selectedIds.slice(); 
    if (idsToAdd.length === 0) return;

    try {
      setIsAdding(true);
      await Promise.resolve(onAddAll(idsToAdd)); 
      setSelectedIds([]); 
    } finally {
      setIsAdding(false);
    }
  };

const disabled = selectedIds.length === 0 || isAdding;
  return (
   <div
      style={{
        position: "relative",
        zIndex: 0,   
      }}
  >

      {/* Add All button */}
      <div style={{ marginBottom: 16, textAlign: "right" }}>
        <button
          type="button"
          className="button-secondary"
          onClick={handleAddAll}
          disabled={disabled}
          style={{
            opacity: disabled ? 0.5 : 1,
            cursor: disabled ? "not-allowed" : "pointer",
          }}
        >
          {isAdding ? "Adding..." : "Add All"}
        </button>
      </div>

      <table
        style={{
          width: "100%",
          tableLayout: "fixed",
        }}
        className="table study"
      >
        <tbody>
          <tr>
            <th>Select</th>
            <th>Id</th>
            <th>External step name</th>
            <th>Url</th>
          </tr>
          {data.map((item, index) => (
            <tr key={index}>
              <td>
                <input
                  type="checkbox"
                  style={{
                    width: "16px",
                    height: "16px",
                    visibility: "visible",
                    display: "inline-block",
                  }}
                  checked={selectedIds.includes(item.id)}
                  onChange={() => toggleSelect(item.id)}
                />
              </td>
              <td>{item.id}</td>
              <td>{item.name}</td>
              <td>
                {copied === item.url ? (
                  <MuiAlert
                    onClose={() => setCopied(false)}
                    className="mb-4"
                    severity="success"
                  >
                    <span>Copied successfully</span>
                  </MuiAlert>
                ) : null}

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 24,
                    justifyContent: "space-between",
                    paddingRight: 16,
                  }}
                >
                  <p>{item.url ? item.url.substring(0, 24) + "..." : item.url}</p>

                  <CopyToClipboard text={item.url} onCopy={() => setCopied(item.url)}>
                    <Tooltip title="Copy URL to clipboard">
                      <Fab size="small" style={{ background: "#00badb" }}>
                        <ContentCopyIcon style={{ color: "white", fontSize: 18}} />
                      </Fab>
                    </Tooltip>
                  </CopyToClipboard>
                </div>
              </td>
              
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

ExternalTable.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.array,
  onAddAll: PropTypes.func,
};

export default ExternalTable;
